import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SignatureService, SignatureContext } from '../../../core/services/signature.service';

@Component({
  selector: 'app-signature-options',
  templateUrl: './signature-options.component.html',
  styleUrls: ['./signature-options.component.scss']
})
export class SignatureOptionsComponent implements OnInit {
  @Input() includeSignature: boolean = false;
  @Input() selectedDoctor: any = null;
  @Input() showCheckbox: boolean = true;
  @Input() showDoctorSelection: boolean = true;
  @Input() disabled: boolean = false;
  @Input() label?: string;

  @Output() includeSignatureChange = new EventEmitter<boolean>();
  @Output() selectedDoctorChange = new EventEmitter<any>();

  signatureContext!: SignatureContext;

  constructor(private signatureService: SignatureService) {}

  ngOnInit(): void {
    this.signatureContext = this.signatureService.getSignatureContext();
    
    // Set default label if not provided
    if (!this.label) {
      this.label = this.signatureContext.signatureLabel;
    }
  }

  onIncludeSignatureChange(value: boolean): void {
    this.includeSignature = value;
    this.includeSignatureChange.emit(value);
  }

  onSelectedDoctorChange(doctor: any): void {
    this.selectedDoctor = doctor;
    this.selectedDoctorChange.emit(doctor);
  }

  get canShowDoctorSelection(): boolean {
    return this.signatureContext.hasSignaturePermission && 
           this.showDoctorSelection && 
           this.includeSignature;
  }

  get canShowCheckbox(): boolean {
    return this.signatureContext.canSign && this.showCheckbox;
  }
} 